import { Gender } from '@core/models';
import { selectCurrentLanguage } from '@core/modules/language/features/language.slice';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { logout } from '@core/modules/user/features/user.slice';

export interface MasterDataState {
  pending: boolean;
  genders: Gender[];
}

const initialState: MasterDataState = {
  pending: false,
  genders: []
};

export const masterDataSlice = createSlice({
  name: 'masterData',
  initialState,
  reducers: {
    loadGenders: (state) => {
      state.pending = true;
    },
    loadGendersFulfilled: (state: MasterDataState, action: PayloadAction<Gender[]>) => {
      state.genders = action.payload;
      state.pending = false;
    },
    loadGendersRejected: (state: MasterDataState) => {
      state.genders = [];
      state.pending = false;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(logout, () => initialState);
  }
});

const {
  name,
  reducer,
  actions: { loadGenders, loadGendersFulfilled, loadGendersRejected }
} = masterDataSlice;

export default masterDataSlice.reducer;
export { name, loadGenders, loadGendersFulfilled, loadGendersRejected };

export const selectFeature = createFeatureSelector<ReturnType<typeof reducer>>(name);

export const selectGenders = createSelector(selectFeature, (state) => state.genders);

export const selectGendersOptions = createSelector(
  selectFeature,
  selectCurrentLanguage,
  (state, language) =>
    state.genders.map((gender) => ({
      ...gender,
      name: gender.name[language!.locale]
    }))
);
